import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const AdvertiseIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M24 2.59A2.55 2.55 0 0 0 21.5 0h-19A2.55 2.55 0 0 0 0 2.59V16.5a3 3 0 0 0 3 3h7.25a.25.25 0 0 1 .25.25v2a.25.25 0 0 1-.25.25H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2h-6.25a.25.25 0 0 1-.25-.25v-2a.25.25 0 0 1 .25-.25H21a3 3 0 0 0 3-3ZM2.5 15a.5.5 0 0 1-.5-.5V2.59A.55.55 0 0 1 2.5 2h19a.55.55 0 0 1 .5.59V14.5a.5.5 0 0 1-.5.5Z"
      />
      <path
        fill="currentColor"
        d="M8.36 8.22a1.86 1.86 0 0 0 .89 3.49a1.8 1.8 0 0 0 .87-.23l.14-.07v.05a3 3 0 0 0 2.54 2h.11a.8.8 0 0 0 .1-1.59a1.4 1.4 0 0 1-1.18-.87a.9.9 0 0 0-.14-.27a10.9 10.9 0 0 1 4.44-1a.64.64 0 0 0 .53-.94l-2.42-4.5a.64.64 0 0 0-1.07-.08A11.7 11.7 0 0 1 8.91 7.9Z"
      />
    </svg>
  );
};

export default AdvertiseIcon;
